import React, { useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { useGetOutletsForCustomersQuery } from "../slices/OutletSlice";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setCredentials } from "../slices/authSlice";
import Loader from "../components/Loader";
import Message from "../components/Message";
import { setFoodList } from "../slices/foodListSlice";
import MemberImage from "../components/ImageManager";

const HomePageScreen = () => {
  const navigate = useNavigate();
  const { id: outlets } = useParams();
  const { userInfo } = useSelector((state) => state.auth);
  // console.log("outletsIds");
  // console.log(outlets);
  const dispatch = useDispatch();

  const apiQuery = `outletGroup=${outlets.split("-")[0]}`;

  const {
    data: outletsDetails,
    isLoading,
    error,
    refetch,
  } = useGetOutletsForCustomersQuery({ query: apiQuery });

  const outlet = outletsDetails?.[0]; // Get the first outlet from array
  const company = outlet?.companyId;

  console.log("openedOutletGroup");
  console.log(outlets.split("-")[0]);

  useEffect(() => {
    dispatch(
      setCredentials({
        ...userInfo,
        openedOutletGroup: outlets.split("-")[0],
        outletsDetails: outletsDetails,
        deliveryTo: `${outlets.split("-")[1]} , ${outlets.split("-")[2]}`,
      })
    );
    dispatch(setFoodList([]));
  }, [outletsDetails]);

  useEffect(() => {
    if (userInfo?.openedOutletGroup !== outlets.split("-")[0])
      dispatch(
        setCredentials({
          ...userInfo,
          selectedItems: {},
        })
      );
  }, [outlets]);

  const handleOrderFoodClick = () => {
    navigate("/foodsList/" + outlets.split("-")[0], {
      state: {
        companyName: company?.companyName,
        deliveryTo: `${outlets.split("-")[1]} , ${outlets.split("-")[2]}`,
      },
    });
  };
  return (
    <>
      <Row
        style={{
          alignItems: "center",
          justifyContent: "center",
          display: "flex",
          flexDirection: "row",
          width: "90%",
          margin: "auto",
          textAlign: "center",
          marginTop: "3rem",
          color: "black",
        }}
      >
        {isLoading ? (
          <Loader />
        ) : error ? (
          <Message>Something went wrong</Message>
        ) : (
          <Col md={8} sm={6} xs="auto" style={{ color: "black" }}>
            <div className="home-heading">
              <h5>Welcome to</h5>
              <br />
              <h1>{outlet?.companyId?.companyName}</h1>
              <h6>{outlet?.companyId?.companyCity}</h6>
              <br />
              <br />
              {outlets.split("-")[1] && (
                <>
                  <h5>
                    Seat - {outlets.split("-")[1]} , {outlets.split("-")[2]}
                  </h5>
                  <br />
                  <br />
                </>
              )}

              <MemberImage
                foodItemId={
                  outletsDetails[0]?.companyId?._id +
                  "" +
                  outletsDetails[0]?.companyId?._id +
                  "" +
                  outletsDetails[0]?.companyId?._id
                }
                imageUpdatedTimeFromDB={
                  outletsDetails[0]?.companyId?.imageUploadedTime
                }
                currentlySelling={true}
                photoUploaded={outletsDetails[0]?.companyId?.imageUploaded}
                width="17rem"
                height="17rem"
              />
              <br />
              <br />
              <br />
              <br />
              <Button className="order-btn" onClick={handleOrderFoodClick}>
                Order Food
              </Button>
              <br />
              <br />
              <br />
              <br />
              <a href="#" className="order-history-link">
                Order History
              </a>
            </div>
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            Powered By
            <br />
            <a href="https://www.zpotter.in">zpotter technologies </a>
          </Col>
        )}
      </Row>
    </>
  );
};

export default HomePageScreen;
